export default "__VITE_ASSET__D$3KxoWN__"